import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GlobalExclusionsAppDataProviderFactory } from '../factory/GlobalExclusionsAppDataProviderFactory';
import { GlobalExclusionsAppBaseDataProvider } from '../dataProvider/GlobalExclusionsAppBaseDataProvider';
import { GlobalExclusionsAppWebComponentSchema } from '../types';

export class GlobalExclusionsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GlobalExclusionsAppDataProviderFactory;
  public dataProvider: GlobalExclusionsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GlobalExclusionsAppDataProviderFactory(),
    });
  }

  async getGlobalExclusionsData(companyId): Promise<GlobalExclusionsAppWebComponentSchema | any> {
    let response;
    try {
      response = await this.dataProvider.getGlobalExclusionsData(companyId);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

  public async getListInfo(companyId, listId): Promise<any> {
    let response;
    try {
      response = await this.dataProvider.getListInfo(companyId, listId);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

}
